import { createSelector } from '@ngrx/store';

export const selectTempDataState = (state) => state.tempData;

export const selectInvSumGridData = createSelector(selectTempDataState, (state) => state.invSumGridData);

export const selectInvDtlGridData = createSelector(selectTempDataState, (state) => state.invDtlGridData);

export const selectInvLotGridData = createSelector(selectTempDataState, (state) => state.invLotGridData);

export const selectOrdInqGridData = createSelector(selectTempDataState, (state) => state.ordInqGridData);

export const selectOrdDtlGridData = createSelector(selectTempDataState, (state) => state.ordDtlGridData);

export const selectOrdModHdrDataData = createSelector(selectTempDataState, (state) => state.ordModHdrData);

export const selectOrdModDtlGridData = createSelector(selectTempDataState, (state) => state.ordModDtlGridData);

export const selectReportListGridData = createSelector(selectTempDataState, (state) => state.reportListGridData);

export const selectUserLookupGridData = createSelector(selectTempDataState, (state) => state.userLookupGridData);

export const selectUserDetailLookupGridData = createSelector(selectTempDataState, (state) => state.userLookupDetailData);
